// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__xFc33","content":"LayoutSettings_content__1FDrd"};